import { getDurationContent } from '../../../core/components/overlay-tooltip/components/header/utils/get-duration-content.js';
import type {
  DateTimeFormatter,
  FormatterWithPrecision,
} from '../../../core/types/formatter.js';
import { scaleBandInvert } from '../../../core/utils/scale.js';
import {
  isAnyNumericalScale,
  isCategoricalScale,
  isTimeScale,
} from '../../types/guards.js';
import {
  type AnyXYChartScale,
  type XYChartAxisInternal,
} from '../../types/xy-chart-internals.js';
import { getTimeframe } from '../overlay/utils/get-timeframe.js';

export const getHeaderProps = ({
  axisConfig,
  scale,
  formatter,
  startPixels,
  endPixels,
  suffix,
}: {
  axisConfig: XYChartAxisInternal;
  scale: AnyXYChartScale;
  formatter: FormatterWithPrecision | DateTimeFormatter;
  startPixels: number;
  endPixels: number;
  suffix: '1' | '2';
}) => {
  const config = {
    axisType: axisConfig.type,
    axisScale: scale,
  };

  const timeframe = getTimeframe(
    startPixels,
    endPixels,
    !axisConfig?.reversed,
    scale,
  );
  if (isAnyNumericalScale(config) && !isTimeScale(config)) {
    const from = config.axisScale.invert(startPixels) as number;
    const to = config.axisScale.invert(endPixels) as number;
    return {
      [`header${suffix}`]: [formatter(from), formatter(to)],
      [`duration${suffix}`]: formatter(
        getDurationContent(true, [from, to]) as number,
      ),
    };
  }
  if (isTimeScale(config)) {
    return {
      [`header${suffix}`]: [timeframe.start, timeframe.end],
      [`showRangeDuration${suffix}`]: true,
    };
  }
  if (isCategoricalScale(config)) {
    return {
      [`header${suffix}`]: [
        scaleBandInvert(config.axisScale)(startPixels),
        scaleBandInvert(config.axisScale)(endPixels),
      ],
    };
  }
};
